<script>
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import session from '../../lib/session.js';
  import { onMount } from 'svelte';
  import Dialog from '../../lib/components/Dialog.svelte';
  import { compareStrings } from '../../lib/utils';
  import DialogLanguage from './DialogLanguage.svelte';
  import DialogEducation from './DialogEducation.svelte';

  // component options  ------------------------------------------------------ //

  export let input;

  // internal variables ------------------------------------------------------ //

  let dialog_edu;
  let dialog_language;
  let dialog_edit_lang = false;
  let dialog_edit_edu = false;
  let dialog_edit_id_lang = null;
  let dialog_edit_id_edu = null;
  let dialog_btn = null;
  let api_calls = 0;

  let form_input = {
    trigger_focus: true,
    has_triggered: false,
    language: {
      language: null,
      proficiency: null,
      language_edit: null,
      proficiency_edit: null,
      input_value_language: null,
      input_value_proficiency: null,
    },
    education: {
      type: null,
      type_edit: null,
      title: null,
      where: null,
      input_value_education: null,
      input_value_year: null,
      input_value_month: null,
      completed: {
        month: null,
        year: null,
        month_edit: null,
        year_edit: null,
        current: null,
      },
    },
  };

  // translated strings -------------------------------------------------------- //

  let labels = {
    language: null,
    proficiency: null,
    no_language_added: null,
    no_education_added: null,
    add_language: null,
    add_education: null,
    type: null,
    title: null,
    where: null,
    completed: null,
    in_progress: null,
    btn_back: null,
    btn_next: null,
    btn_close: null,
    btn_add: null,
    btn_cancel: null,
    btn_yes: null,
    btn_save: null,
    completed_month: null,
    completed_year: null,
    current: null,
    edit_lang: null,
    edit_edu: null,
    tooltip: {
      language: null,
      education: null,
    },
    dialog: {
      delete_lang: {
        title: null,
        content: null,
      },
      delete_edu: {
        title: null,
        content: null,
      },
    },
    languages: {
      ar: null,
      en: null,
      fa: null,
      fi: null,
      ru: null,
      sv: null,
    },
  };

  // utility functions -------------------------------------------------------- //

  const create_delete_dialog_lang = index => {
    let target = document.querySelector('.delete-dialog-lang');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'deletedialoglang',
        title: labels.dialog.delete_lang.title,
        content: labels.dialog.delete_lang.content,
        buttons: [
          {
            label: labels.btn_cancel,
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: labels.btn_yes,
            action: () => {
              delete_list_elem_lang(index);
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });
    // close_dialog_language();
    dialog.open();
  };

  const create_delete_dialog_edu = index => {
    let target = document.querySelector('.delete-dialog-edu');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'deletedialogedu',
        title: labels.dialog.delete_lang.title,
        content: labels.dialog.delete_lang.content,
        buttons: [
          {
            label: labels.btn_cancel,
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: labels.btn_yes,
            action: () => {
              delete_list_elem_edu(index);
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });
    dialog.open();
  };

  const delete_list_elem_lang = index => {
    let tmp_array = input.languages;
    tmp_array.splice(index, 1);
    input.languages = tmp_array;
  };

  const delete_list_elem_edu = index => {
    let tmp_array = input.educations;
    tmp_array.splice(index, 1);
    input.educations = tmp_array;
  };

  const translate_language = lang => {
    for (let i = 0; i < selectors.language.languages.length; i++) {
      if (selectors.language.languages[i].val === lang) {
        return t9n(selectors.language.languages[i].name);
      }
    }
  };

  const init_year_array = () => {
    let tmp_array = [];
    let date = new Date();
    let year = date.getFullYear();
    for (let i = year; i >= 1970; i--) {
      tmp_array.push({ name: i.toString(), val: i });
    }
    return tmp_array;
  };

  let selectors = {
    language: {
      proficiency: [
        {
          name: t9n('worker_language_limited'),
          val: 'worker_language_limited',
        },
        {
          name: t9n('worker_language_elementary'),
          val: 'worker_language_elementary',
        },
        {
          name: t9n('worker_language_intermediate'),
          val: 'worker_language_intermediate',
        },
        {
          name: t9n('worker_language_advanced'),
          val: 'worker_language_advanced',
        },
        {
          name: t9n('worker_language_professional'),
          val: 'worker_language_professional',
        },
        { name: t9n('worker_language_fluent'), val: 'worker_language_fluent' },
      ],
      languages: [],
      filtered_languages: [],
      filtered_languages_edit: [],
    },
    education: {
      type: [
        {
          name: t9n('worker_education_type_education'),
          val: 'worker_education_type_education',
        },
        {
          name: t9n('worker_education_type_course'),
          val: 'worker_education_type_course',
        },
        {
          name: t9n('worker_education_type_certificate'),
          val: 'worker_education_type_certificate',
        },
      ],
      months: [
        { name: 'January', val: 1 },
        { name: 'February', val: 2 },
        { name: 'March', val: 3 },
        { name: 'April', val: 4 },
        { name: 'May', val: 5 },
        { name: 'June', val: 6 },
        { name: 'July', val: 7 },
        { name: 'August', val: 8 },
        { name: 'September', val: 9 },
        { name: 'October', val: 10 },
        { name: 'November', val: 11 },
        { name: 'December', val: 12 },
      ],
      years: init_year_array(),
    },
  };

  const init_share = () => {
    // dialog_language = new MDCDialog(document.getElementById(`language-dialog`));
    // dialog_edu = new MDCDialog(document.getElementById(`edu-dialog`));

    // selectors.language.proficiency.sort((a, b) => {
    //   return compareStrings(a.name, b.name);
    // });
    selectors.education.type.sort((a, b) => {
      return compareStrings(a.name, b.name);
    });

    const languages = $session.api_config.languages;
    const keys = Object.keys(languages);






    selectors.language.languages = keys.map(k => {
      return {
        name: t9n(TS[`SETTINGS_LANG_${k.toUpperCase()}`]),
        val: k,
      };
    });
  };

  const filter_languages = (languages, selector) => {
    let filtered_langs = [];
    let added_langs = [];
    for (let i = 0; i < languages.length; i++) {
      added_langs.push(languages[i].language);
    }
    for (let i = 0; i < selector.length; i++) {
      if (!added_langs.includes(selector[i].val)) {
        filtered_langs.push(selector[i]);
      }
    }
    selectors.language.filtered_languages = filtered_langs;
  };

  const filter_languages_edit = (languages, selector, form_input) => {
    let filtered_langs = [];
    let added_langs = [];
    for (let i = 0; i < languages.length; i++) {
      added_langs.push(languages[i].language);
    }
    for (let i = 0; i < selector.length; i++) {
      if (
        !added_langs.includes(selector[i].val) ||
        form_input === selector[i].val
      ) {
        filtered_langs.push(selector[i]);
      }
    }
    selectors.language.filtered_languages_edit = filtered_langs;
  };

  const add_new_language = () => {
    let new_experience = {
      language: form_input.language.language,
      proficiency: form_input.language.proficiency,
    };
    let tmp_exp = input.languages;

    if (!dialog_edit_lang) {
      tmp_exp.push(new_experience);
    } else {
      for (let i = 0; i < tmp_exp.length; i++) {
        if (i === dialog_edit_id_lang) {
          tmp_exp[i].language = form_input.language.language_edit;
          tmp_exp[i].proficiency = form_input.language.proficiency_edit;
        }
      }
    }
    close_dialog_language();
    input.languages = tmp_exp;
  };

  const add_new_education = () => {
    let new_education = {
      education_type: form_input.education.type,
      title: form_input.education.title,
      where: form_input.education.where,
      completed_month: form_input.education.completed.month,
      completed_year: form_input.education.completed.year,
      completed_is_current: form_input.education.completed.current,
    };
    let tmp_edu = input.educations;

    if (!dialog_edit_edu) {
      tmp_edu.push(new_education);
    } else {
      for (let i = 0; i < tmp_edu.length; i++) {
        if (i === dialog_edit_id_edu) {
          tmp_edu[i].education_type = form_input.education.type_edit;
          tmp_edu[i].title = form_input.education.title;
          tmp_edu[i].where = form_input.education.where;
          tmp_edu[i].completed_month =
            form_input.education.completed.month_edit;
          tmp_edu[i].completed_year = form_input.education.completed.year_edit;
          tmp_edu[i].completed_is_current =
            form_input.education.completed.current;
        }
      }
    }
    close_dialog_edu();
    input.educations = tmp_edu;
  };

  const open_dialog_language = index => {
    if (index >= 0) {
      dialog_edit_lang = true;
      dialog_edit_id_lang = index;
      dialog_btn = labels.btn_save;
      for (let i = 0; i < input.languages.length; i++) {
        if (i === index) {
          form_input.language.language_edit = input.languages[i].language;
          form_input.language.proficiency_edit = input.languages[i].proficiency;
        }
      }
    } else {
      dialog_btn = labels.btn_add;
      dialog_edit_lang = false;
      form_input.language.language = null;
      form_input.language.proficiency = null;
      form_input.language.input_value_language = null;
      form_input.language.input_value_proficiency = null;
    }
    form_input.has_triggered = false;

    let target = document.querySelector('.dialog-lang');
    target.innerHTML = '';

    dialog_language = new DialogLanguage({
      target: target,
      props: {
        form_input: form_input,
        dialog_edit_lang: dialog_edit_lang,
        add_new_language: add_new_language,
        close_dialog_language: close_dialog_language,
        selectors: selectors,
        input: input,
      },
    });
    dialog_language.open();
  };

  const open_dialog_edu = index => {
    if (index >= 0) {
      dialog_edit_edu = true;
      dialog_edit_id_edu = index;
      dialog_btn = labels.btn_save;
      for (let i = 0; i < input.educations.length; i++) {
        if (i === index) {
          form_input.education.type_edit = input.educations[i].education_type;
          form_input.education.title = input.educations[i].title;
          form_input.education.where = input.educations[i].where;
          form_input.education.completed.month_edit =
            input.educations[i].completed_month;
          form_input.education.completed.year_edit =
            input.educations[i].completed_year;
          form_input.education.completed.current =
            input.educations[i].completed_is_current;
        }
      }
    } else {
      dialog_edit_edu = false;
      dialog_btn = labels.btn_add;
      form_input.education.type = null;
      form_input.education.title = null;
      form_input.education.where = null;
      form_input.education.completed.month = null;
      form_input.education.completed.year = null;
      form_input.education.completed.current = false;
      form_input.education.input_value_education = null;
      form_input.education.input_value_year = null;
      form_input.education.input_value_month = null;
    }
    form_input.has_triggered = false;

    let target = document.querySelector('.dialog-edu');
    target.innerHTML = '';
    dialog_edu = new DialogEducation({
      target: target,
      props: {
        labels: labels,
        close_dialog_edu: close_dialog_edu,
        dialog_edit_edu: dialog_edit_edu,
        form_input: form_input,
        selectors: selectors,
        add_new_education: add_new_education,
      },
    });

    dialog_edu.open();
  };

  const close_dialog_language = () => {
    dialog_language.close();
    dialog_edit_lang = false;
  };

  const close_dialog_edu = () => {
    dialog_edu.close();
    dialog_edit_edu = false;
  };

  const translate_texts = () => {
    labels.autosave = t9n(TS.NEW_ORDER_AUTO_SAVE);
    labels.language = t9n(TS.REGISTER_LABEL_LANGUAGE);
    labels.proficiency = t9n(TS.SETTINGS_LABEL_PROFICIENCY);
    labels.no_language_added = t9n(TS.SETTINGS_LABEL_NO_LANG_ADDED);
    labels.no_education_added = t9n(TS.SETTINGS_LABEL_NO_EDU_ADDED);
    labels.add_language = t9n(TS.SETTINGS_LABEL_ADD_LANG);
    labels.add_education = t9n(TS.SETTINGS_LABEL_ADD_EDU);
    labels.type = t9n(TS.SETTINGS_LABEL_TYPE);
    labels.title = t9n(TS.SETTINGS_LABEL_TITLE);
    labels.where = t9n(TS.SETTINGS_LABEL_WHERE);
    labels.completed = t9n(TS.ORDER_COMPLETED_TXT);
    labels.in_progress = t9n(TS.TABLE_CHIP_IN_PROG);
    labels.btn_back = t9n(TS.TXT_BACK);
    labels.btn_next = t9n(TS.TABLE_BUTTON_NEXT);
    labels.btn_close = t9n(TS.LOGIN_FORM_CLOSE);
    labels.btn_add = t9n(TS.ORDERER_TEAMS_ADD_LABEL);
    labels.btn_cancel = t9n(TS.ORDERER_TEAMS_CANCEL_LABEL);
    labels.btn_yes = t9n(TS.TXT_YES);
    labels.completed_month = t9n(TS.SETTINGS_LABEL_COMPLETED_MONTH);
    labels.completed_year = t9n(TS.SETTINGS_LABEL_COMPLETED_YEAR);
    labels.current = t9n(TS.SETTINGS_LABEL_CURRENT);
    labels.btn_save = t9n(TS.CHANGE_PASSWORD_SUBMIT_LABEL);
    labels.edit_lang = t9n(TS.SETTINGS_LABEL_EDIT_LANG);
    labels.edit_edu = t9n(TS.SETTINGS_LABEL_EDIT_EDU);
    labels.dialog.delete_lang.title = t9n(TS.SETTINGS_LABEL_DELETE);
    labels.dialog.delete_lang.content = t9n(TS.TXT_ARE_YOU_SURE);
    labels.dialog.delete_edu.title = t9n(TS.MENU_LABEL_PERSONALINFO);
    labels.dialog.delete_edu.content = t9n(TS.SETTINGS_LABEL_DELETE);
    labels.languages.ar = t9n(TS.SETTINGS_LABEL_LANG_AR);
    labels.languages.en = t9n(TS.SETTINGS_LABEL_LANG_EN);
    labels.languages.fa = t9n(TS.SETTINGS_LABEL_LANG_FA);
    labels.languages.fi = t9n(TS.SETTINGS_LABEL_LANG_FI);
    labels.languages.ru = t9n(TS.SETTINGS_LABEL_LANG_RU);
    labels.languages.sv = t9n(TS.SETTINGS_LABEL_LANG_SV);
    labels.tooltip.language = t9n(TS.SETTINGS_LABEL_TOOLTIP_LANG);
    labels.tooltip.education = t9n(TS.SETTINGS_LABEL_TOOLTIP_EDU);
    labels.btn_save = t9n(TS.CHANGE_PASSWORD_SUBMIT_LABEL);

    selectors.education.months[0].name = t9n(TS.SETTINGS_LABEL_MONTH_JAN);
    selectors.education.months[1].name = t9n(TS.SETTINGS_LABEL_MONTH_FEB);
    selectors.education.months[2].name = t9n(TS.SETTINGS_LABEL_MONTH_MAR);
    selectors.education.months[3].name = t9n(TS.SETTINGS_LABEL_MONTH_APR);
    selectors.education.months[4].name = t9n(TS.SETTINGS_LABEL_MONTH_MAY);
    selectors.education.months[5].name = t9n(TS.SETTINGS_LABEL_MONTH_JUN);
    selectors.education.months[6].name = t9n(TS.SETTINGS_LABEL_MONTH_JUL);
    selectors.education.months[7].name = t9n(TS.SETTINGS_LABEL_MONTH_AUG);
    selectors.education.months[8].name = t9n(TS.SETTINGS_LABEL_MONTH_SEP);
    selectors.education.months[9].name = t9n(TS.SETTINGS_LABEL_MONTH_OCT);
    selectors.education.months[10].name = t9n(TS.SETTINGS_LABEL_MONTH_NOV);
    selectors.education.months[11].name = t9n(TS.SETTINGS_LABEL_MONTH_DEC);
  };

  // reactive functions -------------------------------------------------------- //

  $: filter_languages(input.languages, selectors.language.languages);
  $: filter_languages_edit(
    input.languages,
    selectors.language.languages,
    form_input.language.language_edit
  );

  $: if (!!$session) translate_texts();

  onMount(init_share);
</script>

<div class="margin-24 mobile-margin">
  <!-- Help line -->
  <div id="help-liner" class="">
    <div class="tooltip-default ">
      <span id="tooltip_def" class="tooltip-text tooltip-top">
        {labels.tooltip.language}
      </span>
    </div>
  </div>

  <!-- Here is the table for languages -->
  <div id="languages_panel" style="margin-top: 15px">
    <table id="languages" class="table">
      <!-- Languages loop -->
      <tr class="tr-head">
        {#if input.languages.length > 0}
          <td
            class="height /*font-style: italic; font-weight: bold;*/"
            colspan="1">
            {labels.language}
          </td>
          <td colspan="1">{labels.proficiency}</td>
          <td colspan="1" />
        {/if}

        <!-- <td style="vertical-align: bottom; text-align: right"><button class="mdc-button hover" style="color: #bb0000;">{"Remove"}</button></td>-->
      </tr>

      {#if !!input.languages}
        {#if input.languages.length === 0}
          <tr>
            <td class="break height" colspan="1">{labels.no_language_added}</td>
            <td class="break" colspan="1" />
            <td class="break" colspan="1" />
            <!-- <td style="vertical-align: bottom; text-align: right"><button class="mdc-button hover" style="color: #bb0000;">{"Remove"}</button></td>-->
          </tr>
        {:else}
          {#each input.languages as lang, i}
            <tr class="tr-click">
              <td
                class="break height"
                on:click={() => open_dialog_language(i)}
                colspan="1">
                {#if selectors.language.languages.length > 0}
                  {translate_language(lang.language)}
                {/if}
              </td>
              <td
                class="break"
                on:click={() => open_dialog_language(i)}
                colspan="1">
                {t9n(lang.proficiency)}
              </td>
              <td
                class="break"
                style="text-align: center"
                colspan="1"
                on:click={() => create_delete_dialog_lang(i)}>
                <i class="material-icons delete-icon" aria-hidden="true">
                  close
                </i>
              </td>
              <!-- <td style="vertical-align: bottom; text-align: right"><button class="mdc-button hover" style="color: #bb0000;">{"Remove"}</button></td>-->
            </tr>
          {/each}
        {/if}
      {/if}

    </table>

    <!-- Add language button -->
    <div style="text-align: left">
      <button
        data-cy="add_language_button"
        style="margin-right: 10px"
        class="mdc-button mdc-button--raised"
        on:click|stopPropagation|preventDefault={() => open_dialog_language(-1)}>
        {labels.add_language}
      </button>
    </div>
  </div>

  <br />
  <div id="help-liner-education" class="">
    <div class="tooltip-default ">
      <span id="tooltip_edu" class="tooltip-text tooltip-top">
        {labels.tooltip.education}
      </span>
    </div>
  </div>

  <div id="educations_panel" style="margin-top: 15px">
    <table id="educations" class="table">
      <!-- Educations loop -->
      <tr class="tr-head">
        {#if input.educations.length > 0}
          <td class="height" colspan="2">{labels.type}</td>
          <td colspan="1">{labels.title}</td>
          <td colspan="1">{labels.where}</td>
          <td colspan="1">{labels.completed}</td>
          <td colspan="1" />
        {/if}

        <!-- <td style="vertical-align: bottom; text-align: right"><button class="mdc-button hover" style="color: #bb0000;">{"Remove"}</button></td>-->
      </tr>
      {#if !!input.educations}
        {#if input.educations.length === 0}
          <tr>
            <td class="height" colspan="2">{labels.no_education_added}</td>
            <td colspan="1" />
            <td colspan="1" />
            <td colspan="1" />
            <td colspan="1" />
            <!-- <td style="vertical-align: bottom; text-align: right"><button class="mdc-button hover" style="color: #bb0000;">{"Remove"}</button></td>-->
          </tr>
        {:else}
          <!--                    completed_is_current: false-->
          <!--                    completed_month: 3-->
          <!--                    completed_year: 2018-->
          <!--                    education_type: "worker_education_type_certificate"-->
          <!--                    id: 208-->
          <!--                    title: "jddj"-->
          <!--                    where: "djdjd"-->
          {#each input.educations as education, i}
            <tr class="tr-click tr-resp">
              <td
                on:click={() => open_dialog_edu(i)}
                class="height data-heading td-resp"
                colspan="2">
                {t9n(education.education_type)}
              </td>
              <td
                on:click={() => open_dialog_edu(i)}
                class="title-where data-heading td-resp"
                colspan="1">
                {education.title}
              </td>
              <td
                on:click={() => open_dialog_edu(i)}
                class="title-where data-heading td-resp"
                colspan="1">
                {education.where}
              </td>
              <td
                on:click={() => open_dialog_edu(i)}
                class="data-heading td-resp"
                colspan="1">
                {#if education.completed_is_current}
                  {labels.in_progress}
                {:else}{education.completed_year}{/if}
              </td>
              <td
                colspan="1"
                on:click={() => create_delete_dialog_edu(i)}
                class="td-resp"
                style="text-align: center">
                <i
                  class="material-icons delete-icon"
                  style="margin-right: 17px;"
                  aria-hidden="true">
                  close
                </i>
              </td>
              <!-- <td style="vertical-align: bottom; text-align: right"><button class="mdc-button hover" style="color: #bb0000;">{"Remove"}</button></td>-->
            </tr>
          {/each}
        {/if}
      {/if}

    </table>

    <!-- Add edu button -->
    <div style="text-align: left">
      <button
        data-cy="add_edu_button"
        style="margin-right: 10px"
        class="mdc-button mdc-button--raised"
        on:click|stopPropagation|preventDefault={() => open_dialog_edu(-1)}>
        {labels.add_education}
      </button>
    </div>
  </div>

  <!-- Prev / Save buttons -->
  <div style="display: flex; justify-content: flex-end; margin-top: 32px; position: relative">
<!--    <p class="changes-text">{labels.autosave}</p>-->
    <div style="margin-right: 10px;">
      <button
        onclick="prev_tab()"
        class="mdc-button mdc-button--outlined margin-5">
        <span class="mdc-button__ripple" />
        {labels.btn_back}
      </button>
    </div>

    <button
      onclick="next_tab()"
      data-cy="next"
      class="mdc-button mdc-button--unelevated margin-5">
      <span class="mdc-button__ripple" />
      {labels.btn_next}
    </button>

<!--    <button-->
<!--            onclick="update_profile()"-->
<!--            class="mdc-button mdc-button&#45;&#45;unelevated margin-5"-->
<!--            style="margin-left: 10px"-->
<!--            data-cy="save">-->
<!--      <span class="mdc-button__ripple"/>-->
<!--      {labels.btn_save}-->
<!--    </button>-->
  </div>

  <!-- Hidden 'Add new experience' dialog -->
  <!--    <div class="add-dialog"></div>-->
</div>

<div class="delete-dialog-lang" />
<div class="delete-dialog-edu" />
<div class="dialog-lang" />
<div class="dialog-edu" />

<style>
  .changes-text{
    margin-top: 10px;
    margin-right: 10px;
    position: absolute;
    left: 0px;
    opacity: .5;
    font-size: 14px;
  }
  table {
    width: 100%;
    margin-bottom: 15px;
    /*background: #eef0f0;*/
    /*line-height: 2.5;*/
    /*!*padding-left: 15px;*!*/
    /*border-spacing: 0;*/
    background-color: var(--mdc-theme-surface, #fff);
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.12);
    -webkit-overflow-scrolling: touch;
    /*display: inline-flex;*/
    flex-direction: column;
    /*border-collapse: collapse;*/
    border-spacing: 0;
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.87);
  }

  .tr-head {
    background-color: blanchedalmond;
  }

  td {
    /*border-bottom: 1px solid #b7b7b7;*/
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    font-family: Roboto, sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    text-transform: inherit;
  }

  h6 {
    font-weight: normal;
    margin-bottom: -50px;
    margin-top: 1px;
  }

  #languages td {
    /*border: none;*/
    color: #7a7676;
    color: rgba(0, 0, 0, 0.87);
    padding-left: 15px;
    /*border-bottom: 1px solid #b7b7b7;*/
  }

  #educations td {
    color: #7a7676;
    color: rgba(0, 0, 0, 0.87);
    padding-left: 15px;
    /*border-bottom: 1px solid #b7b7b7;*/
  }

  .label {
    text-align: right;
  }

  .hover:hover {
    background: #f4d1d14d;
    border-radius: 7px;
    height: 33px;
  }

  .title-where {
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tr-click {
    cursor: pointer;
  }

  .height {
    height: 46px;
  }

  .delete-icon {
    position: relative;
    /*top: -7px;*/
    /*left: 50px;*/
    color: red;
    cursor: pointer;
    vertical-align: bottom;
  }

  a:link {
    text-decoration: none;
  }

  /*#language-dialog .mdc-dialog__surface {*/
  /*    max-width: 600px;*/
  /*    width: 600px;*/
  /*    height: 600px;*/
  /*    max-height: 600px;*/
  /*}*/

  .mdc-dialog__surface {
    width: 450px;
  }

  /* Tooltip
    *******************************************************/

  .tooltip-default {
    position: relative;
    font-size: 12px;
    /*top: -60px;*/
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    /*position: absolute;*/
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    left: -300px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  .fade-in-long {
    animation: transition_in 2.5s;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .margin-50 {
      margin-left: 50px;
    }

    .margin-24 {
      margin-right: 24px;
    }

    .mobile-margin {
      margin-left: 24px;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .margin-50 {
      margin-left: 50px;
    }

    .title-where {
      max-width: 180px;
    }

    .margin-24 {
      margin-right: 24px;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .margin-50 {
      margin-left: 1px;
    }

    .margin-24 {
      margin-right: 1px;
    }

    .mobile-margin {
        margin-left: 43px;
    }

    .break {
      word-break: break-all;
    }

    table {
      width: 100%;
    }

    .tr-head {
      display: none;
    }

    .td-resp {
      display: block;
      height: 100%;
      text-align: center;
      border-bottom: none;
    }

    .tr-resp {
      display: block;
      border-bottom: none;
    }

    .td-resp:first-child {
      text-align: center;
      border-top: 1px solid #b7b7b7;
    }

    .title-where {
      /*max-width: 280px;*/
      margin: auto;
    }

    .td-resp:before {
      content: attr(data-heading);
      text-align: center;
    }

    #educations td {
      border-bottom: none;
    }

    .delete-icon {
      position: static;
      vertical-align: middle;
    }
  }
</style>
